import { ResourcesConfig } from "aws-amplify";

export const amplifyConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
      userPoolClientId: import.meta.env.VITE_COGNITO_CLIENT_ID,
      loginWith: {
        oauth: {
          domain: import.meta.env.VITE_COGNITO_DOMAIN.replace(
            /^https?:\/\//,
            "",
          ),
          providers: ["Google", "Apple"],
          scopes: [
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin",
          ],
          redirectSignIn: import.meta.env.VITE_OAUTH_REDIRECT_SIGN_IN.split(
            ",",
          ),
          redirectSignOut: import.meta.env.VITE_OAUTH_REDIRECT_SIGN_OUT.split(
            ",",
          ),
          responseType: "code",
        },
        email: true,
        username: false,
      },
    },
  },
};
